import React from "react";
import styled from "styled-components";

export const IconNotification = (props: any) => {
  return (
    <React.Fragment>
      {props.icon && (
        <Container onClick={props?.onClickIcon}>
          <img width={24} height={24} src={props.icon} alt="" />
          <Notification>
            <NumberNotification>{props.countNotification}</NumberNotification>
          </Notification>
        </Container>
      )}
    </React.Fragment>
  );
};

const Notification = styled.div`
  align-items: center;
  background: #002e6c;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  left: 40px;
  position: absolute;
  top: -13px;
  width: 24px;
`;

const NumberNotification = styled.label`
  color: #ffffff;
  cursor: pointer;
  font-family: Montserrat;
  flex: none;
  flex-grow: 0;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  order: 0;
`;

const Container = styled.div`
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 5px 20px rgb(231 231 234 / 80%);
  cursor: pointer;
  display: flex;
  height: 56px;
  justify-content: center;
  position: relative;
  width: 56px;
`;
